import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=3140172b"
import script from "./RegisterSuccess.vue?vue&type=script&lang=ts"
export * from "./RegisterSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports